import { render, staticRenderFns } from "./DivInfoCall.vue?vue&type=template&id=39fffa12&scoped=true&lang=pug&"
import script from "./DivInfoCall.vue?vue&type=script&lang=js&"
export * from "./DivInfoCall.vue?vue&type=script&lang=js&"
import style0 from "./DivInfoCall.vue?vue&type=style&index=0&id=39fffa12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fffa12",
  null
  
)

export default component.exports